<template>
  <footer role="contentinfo">
    <div class="text-center mt-12 flex flex-col items-center">
      <p class="px-5 max-w-150 mb-10">{{ t('partners') }}</p>
      <div>
        <a href="https://www.quebec.ca/" target="_blank">
          <img
            src="@/assets/images/QUEBEC_couleur.svg"
            alt="Logo du gouvernement du Québec."
            height="50px"
          />
          <small> Ministère de l'Éducation </small>
        </a>
      </div>
      <div id="credits" class="my-2 block">
        <small
          ><a href="https://www.quebec.ca/droit-auteur" target="_blank">{{
            `© Gouvernement du Québec, ${new Date().getFullYear()}`
          }}</a></small
        >
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>
